import { QueryClient } from "@tanstack/react-query";

/** Router context factory — one QueryClient per request (SSR-safe). */
export function getContext() {
  return { queryClient: new QueryClient() };
}
